<template>
  <div class="mt-4">
    <v-row dense>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Código da cotação</span>
        <div>
          {{ cotacao.id }}
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="projeto">
        <span class="caption font-weight-bold">Projeto</span>
        <div>
          {{ projeto }}
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="centroCusto">
        <span class="caption font-weight-bold">Centro de custo</span>
        <div>
          {{ centroCusto }}
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.tipoFrete">
        <span class="caption font-weight-bold">Tipo de frete</span>
        <div>
          {{ cotacao.tipoFrete | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.prazoEntrega">
        <span class="caption font-weight-bold">Entregar até</span>
        <div>
          <span v-if="cotacao.prazoEntrega">{{ cotacao.prazoEntrega | date }}</span>
          <span v-else>Não informado</span>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.validade">
        <span class="caption font-weight-bold">Valido até</span>
        <div>
          <span v-if="cotacao.validade">{{ cotacao.validade | date }}</span>
          <span v-else>Não informado</span>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.formaPagamento">
        <span class="caption font-weight-bold">Forma pagamento</span>
        <div>
          <px-forma-pagamento v-if="cotacao.formaPagamento"
                              :forma-pagamento="cotacao.formaPagamento"
                              :prazo-pagamento="cotacao.prazoPagamento"/>
          <span v-if="!cotacao.formaPagamento">Não informado</span>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.observacaoInterna">
        <span class="caption font-weight-bold">Observação interna</span>
        <div>
          <div>
            <px-show-large-text :large-text="cotacao.observacaoInterna"/>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.observacao">
        <span class="caption font-weight-bold">Observação externa</span>
        <div>
          <div>
            <px-show-large-text :large-text="cotacao.observacao"/>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="cotacao.finalidadeCompra">
        <span class="caption font-weight-bold">Finalidade da Compra</span>
        <div v-if="cotacao.finalidadeCompra">
          <px-finalidade-compra-value :finalidade-compra="cotacao.finalidadeCompra"/>
        </div>
        <div v-else>
          Não Informado
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <px-responsaveis
            is-comprador
            :id="cotacao.id"
            :id-company="cotacao.comprador.id"
            :responsaveis="responsaveis"
            :roles="['ROLE_COMPRADOR']"
            :loading-responsaveis="loadingResponsaveis"
            :custom-path="customPath"
            :show-actions="hasRoleCompradorOuGestorCompras"
            modal-title="Alterar compradores responsáveis"
            listagem-title="Compradores responsáveis"
            label-autocomplete-responsavel="Comprador responsável"
            empty-responsaveis-text="Ainda não há nenhum comprador responsável"
            success-message-on-add="Comprador responsável adicionado!"
            success-message-on-remove="Comprador responsável removido!"
            @update-responsaveis="onUpdateResponsaveis"/>
      </v-col>
      <v-col cols="12" sm="6" v-if="isCancelada">
        <span class="caption font-weight-bold">Motivo do cancelamento</span>
        <div>
          <px-show-large-text v-if="cotacao.motivoRecusa" :large-text="cotacao.motivoRecusa"/>
          <span v-else>Acesse o detalhe do item para saber o motivo do cancelamento.</span>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="cotacao.arquivos && cotacao.arquivos.length">
      <v-col cols="12">
        <span class="caption font-weight-bold">Arquivos</span>
        <div>
          <px-anexo-chip :files="cotacao.arquivos"
                         download-base-path="files/download-comprador"/>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col cols="12" sm="6">
        <v-card outlined class="rounded-card" style="height: 100%;">
          <v-subheader>Local de entrega</v-subheader>
          <v-divider/>
          <v-card-text>
            <px-detalhes-locais-entrega small :locais-entrega="cotacao.locaisEntrega"/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card outlined class="rounded-card">
          <v-subheader>Local de faturamento</v-subheader>
          <v-divider/>
          <v-card-text>
            <px-detalhes-comprador small :comprador="cotacao.comprador"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card outlined class="rounded-card">
          <v-subheader>Produtos</v-subheader>
          <v-divider/>
          <px-listagem-cotacao-produtos :cotacao="cotacao" @update="emitUpdate"/>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card outlined class="rounded-card">
          <v-subheader>
            Fornecedores
            <template v-if="isAberta">
              <v-spacer></v-spacer>
              <v-tooltip bottom v-if="hasRoleComprador">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn  small
                          v-bind="attrs"
                          v-on="on"
                          icon
                          :disabled="enviadoTodosEmail"
                          @click="enviarTodosEmail" >
                    <v-icon small
                            color="blue lighten-2">
                            mdi-email-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>Reenviar todos e-mails</span>
              </v-tooltip>
              <v-tooltip bottom v-if="hasRoleComprador">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small
                         v-bind="attrs"
                         v-on="on"
                         icon
                         :disabled="enviadoTodosWhats"
                         @click="enviarTodosWhatsapp" >
                    <v-icon small
                            color="green lighten-1">
                            mdi-whatsapp
                    </v-icon>
                  </v-btn>
                </template>
                <span>Reenviar todos whatsapps</span>
              </v-tooltip>
              <px-cotacao-adicionar-fornecedor-dialog
                  v-if="hasRoleComprador"
                  :cotacao="cotacao"
                  @update="emitUpdate">
                <template v-slot:activator="{ on }">
                  <v-btn x-small
                         class="ml-2 normal-btn-text elevation-0"
                         color="primary"
                         v-on="on">
                    <v-icon x-small>mdi-plus</v-icon>
                    Fornecedor
                  </v-btn>
                </template>
              </px-cotacao-adicionar-fornecedor-dialog>
            </template>
          </v-subheader>
          <v-divider/>
          <px-cotacao-resposta-comprador-card-details-fornecedor
              :solicitacoes="solicitacoes"
              :cotacao="cotacao"
              :enviadoTodosEmail="enviadoTodosEmail"
              :enviadoTodosWhats="enviadoTodosWhats"/>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <px-cotacao-resposta-comprador-card-links :id-cotacao="cotacao.id"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoCotacao } from 'px-business-components';
import { descWithCodigoInterno } from '@/utils/object-utils';
import { CUSTOM_PATH_RESPONSAVEL_COTACAO } from '@/utils/responsaveis-utils';
import ResponsaveisService from '@/api/responsaveis-service';
import CotacaoAdicionarFornecedorDialog
  from '@/modules/cotacao/resposta/components/modal/CotacaoAdicionarFornecedorDialog.vue';
import ListagemCotacaoProdutos from '../../listagem/ListagemCotacaoProdutos.vue';
import CotacaoRespostaCompradorCardDetailsFornecedor
  from './CotacaoRespostaCompradorCardDetailsFornecedor.vue';
import CotacaoRespostaCompradorCardLinks from './CotacaoRespostaCompradorCardLinks.vue';
import RespostaService from '../resposta-service';

export default {
  props: {
    solicitacoes: Array,
    cotacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      responsaveis: [],
      loadingResponsaveis: false,
      enviadoTodosEmail: false,
      enviadoTodosWhats: false,
      loadingEmail: false,
      loadingWhats: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleGestorCompras']),
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao
        || SituacaoCotacao.keys.EM_ANDAMENTO.key === this.cotacao.situacao;
    },
    isCancelada() {
      return SituacaoCotacao.keys.CANCELADA.key === this.cotacao.situacao;
    },
    centroCusto() {
      return this.cotacao.centroCusto
        ? descWithCodigoInterno(this.cotacao.centroCusto) : null;
    },
    projeto() {
      return this.cotacao.projeto ? descWithCodigoInterno(this.cotacao.projeto) : null;
    },
    hasRoleCompradorOuGestorCompras() {
      return this.hasRoleComprador || this.hasRoleGestorCompras;
    },
    customPath() {
      return CUSTOM_PATH_RESPONSAVEL_COTACAO;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    onUpdateResponsaveis() {
      this.getResponsaveisCotacao();
    },
    enviarTodosEmail() {
      this.loadingEmail = true;

      RespostaService.enviarTodosEmails(this.cotacao.id)
        .then(() => {
          this.enviadoTodosEmail = true;
          this.$toast('E-mails reenviados com sucesso!', { color: 'success' });
        })
        .finally(() => {
          this.loadingEmail = false;
        });
    },
    enviarTodosWhatsapp() {
      this.loadingWhats = true;

      RespostaService.enviarTodosWhatsapp(this.cotacao.id)
        .then(() => {
          this.enviadoTodosWhats = true;
          this.$toast('Whatsapps reenviados com sucesso!', { color: 'success' });
        })
        .finally(() => {
          this.loadingWhats = false;
        });
    },
    getResponsaveisCotacao() {
      this.loadingResponsaveis = true;
      ResponsaveisService.get(CUSTOM_PATH_RESPONSAVEL_COTACAO, this.cotacao.id)
        .then((response) => {
          this.responsaveis = response.data;
        })
        .finally(() => {
          this.loadingResponsaveis = false;
        });
    },
  },
  created() {
    this.getResponsaveisCotacao();
  },
  components: {
    pxListagemCotacaoProdutos: ListagemCotacaoProdutos,
    pxCotacaoRespostaCompradorCardDetailsFornecedor: CotacaoRespostaCompradorCardDetailsFornecedor,
    pxCotacaoAdicionarFornecedorDialog: CotacaoAdicionarFornecedorDialog,
    pxCotacaoRespostaCompradorCardLinks: CotacaoRespostaCompradorCardLinks,
  },
};
</script>
